(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvlogDeleteController',PvlogDeleteController);

    PvlogDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pvlog'];

    function PvlogDeleteController($uibModalInstance, entity, Pvlog) {
        var vm = this;

        vm.pvlog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Pvlog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
